import { render, staticRenderFns } from "./ChannelSaleStatistics.vue?vue&type=template&id=6a41ef1a&"
import script from "./ChannelSaleStatistics.vue?vue&type=script&lang=js&"
export * from "./ChannelSaleStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ChannelSaleStatistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports